// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__12N6a","tooltip":"Tooltip_tooltip__2wfxK","visible":"Tooltip_visible__2FZkV","delay":"Tooltip_delay__aw2cf","text":"Tooltip_text__kbLFB"};